import { useAuth } from "@/context/AuthContext";
import { Building2, ChevronDown, Search, Bell } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger, DropdownMenuLabel, DropdownMenuSeparator } from "@/components/ui/dropdown-menu";

export default function Topbar({ title, subtitle }) {
    const { hotels, activeHotelId, switchHotel, user } = useAuth();
    const active = hotels.find((h) => h.id === activeHotelId);

    return (
        <div className="h-16 bg-white border-b border-slate-200 flex items-center justify-between px-6" data-testid="topbar">
            <div className="flex items-center gap-6">
                {hotels.length > 0 && (
                    <DropdownMenu>
                        <DropdownMenuTrigger asChild>
                            <button className="flex items-center gap-2 px-3 py-1.5 border border-slate-200 rounded hover:border-slate-400 transition-colors" data-testid="hotel-switcher">
                                <Building2 className="w-4 h-4 text-slate-500" />
                                <div className="text-left">
                                    <div className="text-xs text-slate-500 leading-none">Property</div>
                                    <div className="text-sm font-medium text-slate-900 leading-tight mt-0.5">
                                        {active?.name || "Select hotel"}
                                    </div>
                                </div>
                                <ChevronDown className="w-4 h-4 text-slate-400 ml-2" />
                            </button>
                        </DropdownMenuTrigger>
                        <DropdownMenuContent className="w-64">
                            <DropdownMenuLabel>Switch Property</DropdownMenuLabel>
                            <DropdownMenuSeparator />
                            {hotels.map((h) => (
                                <DropdownMenuItem key={h.id} onClick={() => switchHotel(h.id)} data-testid={`hotel-option-${h.id}`}>
                                    <div>
                                        <div className="font-medium">{h.name}</div>
                                        <div className="text-xs text-slate-500">{h.city}, {h.country}</div>
                                    </div>
                                </DropdownMenuItem>
                            ))}
                        </DropdownMenuContent>
                    </DropdownMenu>
                )}
                {title && (
                    <div>
                        <h1 className="text-lg font-display font-semibold tracking-tight text-slate-900" data-testid="page-title">{title}</h1>
                        {subtitle && <p className="text-xs text-slate-500">{subtitle}</p>}
                    </div>
                )}
            </div>

            <div className="flex items-center gap-3">
                <div className="relative hidden md:block">
                    <Search className="w-4 h-4 text-slate-400 absolute left-3 top-1/2 -translate-y-1/2" />
                    <input
                        placeholder="Search guests, reservations..."
                        className="pl-9 pr-3 py-1.5 text-sm border border-slate-200 rounded w-64 focus:border-[#0A1C3E] focus:ring-1 focus:ring-[#0A1C3E] outline-none"
                        data-testid="global-search"
                    />
                </div>
                <button className="relative p-2 text-slate-500 hover:text-slate-900" data-testid="notifications-button">
                    <Bell className="w-4 h-4" />
                    <span className="absolute top-1 right-1 w-2 h-2 bg-[#C5B08A] rounded-full" />
                </button>
                <div className="text-xs text-right pr-1">
                    <div className="text-slate-900 font-medium">{user?.name}</div>
                    <div className="text-slate-500 uppercase tracking-wider text-[10px]">{user?.role?.replace(/_/g, " ")}</div>
                </div>
            </div>
        </div>
    );
}
